module.exports = __webpack_public_path__ + "assets/adalyser.da0f36bf.svg";